import type { Column } from "@tanstack/react-table";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface SortableColumnHeaderProps<TData> {
  column: Column<TData, unknown>;
  title: string;
}

/**
 * Header that only sorts (no faceted filter, unlike DataColumnHeader).
 * Click cycles ascending → descending → no sorting.
 */
export function SortableColumnHeader<TData>({ column, title }: SortableColumnHeaderProps<TData>) {
  const sorted = column.getIsSorted();
  const Icon = sorted === "asc" ? ArrowUp : sorted === "desc" ? ArrowDown : ArrowUpDown;

  const cycle = () => {
    if (!sorted) column.toggleSorting(false);
    else if (sorted === "asc") column.toggleSorting(true);
    else column.clearSorting();
  };

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Ordenar por ${title}`}
      className="-ml-1 flex items-center gap-1 whitespace-nowrap rounded p-1 font-medium hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      {title}
      <Icon className={cn("size-3.5 shrink-0", sorted ? "opacity-100" : "opacity-35")} />
    </button>
  );
}
